export default "__VITE_ASSET__DrFKo1fE__"